import { InputChangeEventDetail, IonAlert, IonButton, IonCheckbox, IonCol, IonContent, IonDatetime, IonIcon, IonImg, IonInput, IonLoading, IonPage, IonRow, IonSearchbar } from "@ionic/react";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import HeadFoot from "../Head";
import DataTable from "react-data-table-component";
import CommonDataTable from "../../components/datatable";
import { data } from "jquery";
import Foot from "../Foot";
import Authservice from "../../Services/user.service";
import UserService from "../../Services/auth.service";
import { Button, Form, Modal } from "react-bootstrap";
import Lightbox from "react-image-lightbox";
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { set } from "react-hook-form";
import { useMediaQuery } from "react-responsive";
import { arrowForward, chevronDownOutline, chevronUpOutline } from 'ionicons/icons'; // Example icons
import AdminHead from "./adminHead";
import Sidebar from "./sidebar";
import CommonModal from "../../components/popipInfo";
import { AppContext } from "../../components/AppContext";
import { IonInputCustomEvent } from "@ionic/core";


const FundForVolunteer: React.FC = () => {

    const [usertoken] = useState(sessionStorage.getItem("token"));
    const [userId] = useState(sessionStorage.getItem("UserId"));
    const [showLoading, setShowLoading] = useState(false);
    const [tabledata, settabledata]: any = useState([])
    const [userRole] = useState(sessionStorage.getItem("UserData"));
    const { exportCSV } = useContext(AppContext)!
    const [Commonmodal, setCommonmodal] = useState(false)
    const [CommonModalMesg, setCommonModalMesg] = useState("")
    const [Commmonmodaltitle, setCommonmodaltitle] = useState("")
    const [filterText, setFilterText] = useState("");

    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate]: any = useState("");
    const [showModal, setShowModal] = useState(false);
    const [selectedRow, setSelectedRow]: any = useState(null);

    // Check if mobile view
    const isMobile = useMediaQuery({ maxWidth: 768 });




    const tableData1 = tabledata.filter(
        (item: any) =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );




    const handleRowClick = (row: any) => {
        setSelectedRow(row);
        setShowModal(true);
    };




    const getAllReviewsList = () => {
        console.log(fromDate, toDate);
        if (!fromDate || !toDate) return;
        if (new Date(toDate) < new Date(fromDate)) {
            setCommonModalMesg("To Date cannot be earlier than From Date.");
            setCommonmodaltitle("Error");
            setCommonmodal(true);
            return;
        }
        setShowLoading(true);
        const formatDateTime = (dateString: string) => {
            const selectedDate = new Date(dateString);
            const today = new Date();
            if (
                selectedDate.getFullYear() === today.getFullYear() &&
                selectedDate.getMonth() === today.getMonth() &&
                selectedDate.getDate() === today.getDate()
            ) {
                selectedDate.setHours(today.getHours(), today.getMinutes(), today.getSeconds());
            }
            const year = selectedDate.getFullYear();
            const month = String(selectedDate.getMonth() + 1).padStart(2, "0");
            const day = String(selectedDate.getDate()).padStart(2, "0");
            const hours = String(selectedDate.getHours()).padStart(2, "0");
            const minutes = String(selectedDate.getMinutes()).padStart(2, "0");
            const seconds = String(selectedDate.getSeconds()).padStart(2, "0");
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        };

        const fromdateFormat = formatDateTime(fromDate);
        const todateFormat = formatDateTime(toDate);

        console.log(fromdateFormat, todateFormat);
        Authservice.getFundstoVolunteer(usertoken, userId, usertoken, fromdateFormat, todateFormat)
            .then((response: any) => {
                console.log(response.data);
                settabledata(response.data);
                setShowLoading(false);
            })
            .catch((error: any) => {
                console.error("Error fetching data:", error);
                setShowLoading(false);
            });
    }


    const modalClose = () => {
        if (Commmonmodaltitle === "Information") {
            window.location.reload()
        } else {
            setCommonmodal(false)
        }
    }


    const columns = [
        {
            name: "Booking Order No",
            selector: (row: any) => row.BookingOrderNo,
            sortable: true,
        },
        {
            name: "Booking Date",
            selector: (row: any) => new Date(row.BookingDate).toLocaleDateString(),
            sortable: true,
        },

        {
            name: "Volunteer Amount",
            selector: (row: any) => row.VolAmnt,
            sortable: true,
        },
        {
            name: "Amount",
            selector: (row: any) => row.Amount,
            sortable: true,
            cell: (row: any) => <span style={{ color: row.Amount < 0 ? 'red' : 'green' }}>{row.Amount}</span>
        },
        {
            name: "Order No",
            selector: (row: any) => row.OrderNo,
            sortable: true,
        },
        {
            name: "Pooja Amount",
            selector: (row: any) => row.PoojaAmount,
            sortable: true,
        },
        {
            name: "Volunteer Payment On",
            selector: (row: any) => new Date(row.VolunteerPaymentOn).toLocaleDateString(),
            sortable: true,
        }
    ];


    const formatDate = (timestamp: any) => {
        console.log(timestamp)
        const date = new Date(timestamp);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };




    const conditionalRowStyles = [
        {
            when: (row: any) => row.isUserHeader, // Highlight user rows
            style: {
                backgroundColor: "#e3eeff",
                fontWeight: "bold",
                borderBottom: "1px solid #d3d3d3",
            },
        },
    ];



    // Define handledateChange at the top inside your component
    const subHeaderComponent = useMemo(() => {
        function handledateChange(e: IonInputCustomEvent<InputChangeEventDetail>, arg1: string): void {
            throw new Error("Function not implemented.");
        }

        return (
            <IonRow
                className="table_btn_container"
                style={{
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    alignItems: isMobile ? 'stretch' : 'center',
                    justifyContent: 'space-between',
                    gap: isMobile ? '15px' : '10px',
                    padding: '10px 0',
                    width: '100%'
                }}
            >
                <div style={{
                    display: isMobile ? 'none' : 'block',
                    flex: isMobile ? 'none' : '1'
                }}>
                </div>

                {/* Date controls container */}
                <div style={{
                    display: "flex",
                    flexDirection: isMobile ? 'column' : 'row',
                    alignItems: isMobile ? 'stretch' : "center",
                    gap: isMobile ? "10px" : "10px",
                    width: isMobile ? '100%' : 'auto',
                    flex: isMobile ? 'none' : '2'
                }}>
                    {/* Date inputs row */}
                    <div style={{
                        display: 'flex',
                        flexDirection: isMobile ? 'column' : 'row',
                        gap: isMobile ? '8px' : '10px',
                        width: isMobile ? '100%' : 'auto',
                        alignItems: isMobile ? 'stretch' : 'center'
                    }}>
                        {/* From Date Input with Label */}
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: isMobile ? '100%' : '160px'
                        }}>
                            {isMobile && (
                                <label style={{
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    color: '#333',
                                    marginBottom: '4px',
                                    paddingLeft: '4px'
                                }}>
                                    From Date
                                </label>
                            )}
                            <IonInput
                                type="date"
                                value={fromDate}
                                onIonChange={(e) => handledateChange(e, "from")}
                                placeholder={!isMobile ? "From Date" : ""}
                                style={{
                                    '--background': '#f8f9fa',
                                    '--border-radius': '8px',
                                    '--padding-start': '12px',
                                    '--padding-end': '12px',
                                    '--border': '1px solid #ddd',
                                    fontSize: isMobile ? '14px' : '16px',
                                    minHeight: isMobile ? '40px' : '44px',
                                    width: '100%'
                                }}
                            />
                        </div>

                        {/* To Date Input with Label */}
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: isMobile ? '100%' : '160px'
                        }}>
                            {isMobile && (
                                <label style={{
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    color: '#333',
                                    marginBottom: '4px',
                                    paddingLeft: '4px'
                                }}>
                                    To Date
                                </label>
                            )}
                            <IonInput
                                type="date"
                                value={toDate}
                                onIonChange={(e) => handledateChange(e, "to")}
                                placeholder={!isMobile ? "To Date" : ""}
                                min={fromDate || undefined} // Prevent selecting earlier than from date
                                style={{
                                    '--background': '#f8f9fa',
                                    '--border-radius': '8px',
                                    '--padding-start': '12px',
                                    '--padding-end': '12px',
                                    '--border': '1px solid #ddd',
                                    fontSize: isMobile ? '14px' : '16px',
                                    minHeight: isMobile ? '40px' : '44px',
                                    width: '100%'
                                }}
                            />

                        </div>

                        <div
                            className="forwordGo"
                            onClick={getAllReviewsList}
                            style={{
                                backgroundColor: (!fromDate || !toDate) ? '#364df8ff' : '#364df8ff', // red when inactive, blue when active
                                color: 'white',
                                padding: isMobile ? '12px 20px' : '10px 16px',
                                borderRadius: '8px',
                                cursor: (!fromDate || !toDate) ? 'not-allowed' : 'pointer',
                                textAlign: 'center',
                                fontSize: isMobile ? '14px' : '16px',
                                fontWeight: '500',
                                minWidth: isMobile ? 'auto' : '60px',
                                border: 'none',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginTop: isMobile ? '8px' : '0',
                                pointerEvents: (!fromDate || !toDate) ? 'none' : 'auto'
                            }}
                        >
                            Go
                        </div>

                    </div>

                    {/* Search and Export row */}
                    <div style={{
                        display: 'flex',
                        flexDirection: isMobile ? 'column' : 'row',
                        gap: isMobile ? '8px' : '10px',
                        width: isMobile ? '100%' : 'auto',
                        alignItems: isMobile ? 'stretch' : 'center'
                    }}>
                        <IonSearchbar
                            value={filterText}
                            onIonChange={(e: any) => setFilterText(e.detail.value)}
                            placeholder="Search"
                            className="table_search"
                            style={{
                                '--background': '#bebebeff',
                                '--border-radius': '8px',
                                '--box-shadow': 'none',
                                '--color': '#333',
                                fontSize: isMobile ? '14px' : '16px',
                                minHeight: isMobile ? '40px' : '44px',
                                width: isMobile ? '100%' : '200px',
                                margin: '0'
                            }}
                        />
                        <IonButton
                            className="admin_add_btn"
                            onClick={() => exportCSV(columns, tabledata, "Reviews")}
                            disabled={tabledata.length === 0}
                            style={{
                                '--background': tabledata.length === 0 ? '#364df8ff' : '#364df8ff', // red when no data, green when active
                                '--background-hover': tabledata.length === 0 ? '#364df8ff' : '#364df8ff',
                                '--color': 'white',
                                '--border-radius': '8px',
                                '--padding-start': '16px',
                                '--padding-end': '16px',
                                fontSize: isMobile ? '14px' : '16px',
                                fontWeight: '500',
                                minHeight: isMobile ? '40px' : '44px',
                                width: isMobile ? '100%' : 'auto',
                                margin: '0',
                            }}
                        >
                            Export
                        </IonButton>

                    </div>
                </div>
            </IonRow>
        );
    }, [filterText, tabledata, fromDate, toDate, isMobile]);



    return (
        <IonPage>
            {userRole === "ROLE_ADMIN" && <>
                <AdminHead User={"user"} Role={"Role"} Name={"Fund to Volunteer"} />
                <Sidebar /></>}
            <IonContent>
                <IonLoading
                    isOpen={showLoading}
                    onDidDismiss={() => setShowLoading(false)}
                    message={"Please wait..."}
                />
                {userRole !== "ROLE_ADMIN" && <HeadFoot User={"Fund For Volunteer"} Role="Role" Name='Home,Fund To Volunteer' />}
                <div
                    className={userRole === "ROLE_ADMIN" ? "container_middle_table page-wrapper admin_background_color" : "page_content_padding tableContainev2"}
                    style={{
                        padding: isMobile ? '10px' : undefined,
                        overflow: isMobile ? 'hidden' : 'auto',
                        position: 'relative'
                    }}
                >
                    {tableData1.length === 0 && !showLoading ? (
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            minHeight: '400px',
                            backgroundColor: 'white',
                            margin: '10px 0'
                        }}>
                            {/* Subheader for controls */}
                            {subHeaderComponent}

                            {/* No data message */}
                            <div style={{
                                textAlign: 'center',
                                color: '#6c757d',
                                fontSize: isMobile ? '16px' : '18px',
                                fontWeight: '500',
                                padding: '40px 20px',
                                flex: 1,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                Select Date Range to view data
                            </div>
                        </div>
                    ) : (
                        <CommonDataTable
                            columns={columns}
                            data={tableData1}
                            //  loading={showLoading}
                            noDataComponent={
                                <div style={{
                                    textAlign: 'center',
                                    color: '#6c757d',
                                    fontSize: '16px',
                                    fontWeight: '500',
                                    padding: '40px 20px'
                                }}>
                                    No data available
                                </div>
                            }
                            onRowClick={handleRowClick}
                            conditionalRowStyles={conditionalRowStyles}
                            selectableRows={false}
                            isSubHeader={true}
                            subHeaderComponent={subHeaderComponent}
                            paginationComponentOptions={{
                                noRowsPerPage: true
                            }}
                            customStyles={{
                                table: {
                                    style: {
                                        minHeight: tableData1.length === 0 ? 'auto' : '400px'
                                    }
                                },
                                noData: {
                                    style: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        minHeight: '200px',
                                        backgroundColor: 'white'
                                    }
                                }
                            }}
                        />
                    )}

                </div>
                {userRole !== "ROLE_ADMIN" && <Foot />}

                <CommonModal showModal={Commonmodal} closeModal={modalClose} modaltitle={Commmonmodaltitle} AlertModalMesg={CommonModalMesg} />
            </IonContent>
        </IonPage>
    )
}

export default FundForVolunteer;